import { Actions } from './financial-institutions.actions'
import { fromJS } from 'immutable'
import * as FinancialInstitutionsTypes from './financial-institutions.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  createFinancialInstitution: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateFinancialInstitution: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function financialInstitutionsReducer(
  state = initialState,
  action: Actions,
) {
  switch (action.type) {
    case FinancialInstitutionsTypes.UPDATE_FINANCIAL_INSTITUTION_REQUEST: {
      return state.setIn(['updateFinancialInstitution', 'isLoading'], true)
    }

    case FinancialInstitutionsTypes.UPDATE_FINANCIAL_INSTITUTION_SUCCESS: {
      return state.setIn(['updateFinancialInstitution', 'isLoading'], false)
    }

    case FinancialInstitutionsTypes.UPDATE_FINANCIAL_INSTITUTION_FAILURE: {
      return state.setIn(['updateFinancialInstitution', 'isLoading'], false)
    }

    case FinancialInstitutionsTypes.CREATE_FINANCIAL_INSTITUTION_REQUEST: {
      return state.setIn(['createFinancialInstitution', 'isLoading'], true)
    }

    case FinancialInstitutionsTypes.CREATE_FINANCIAL_INSTITUTION_SUCCESS: {
      return state.setIn(['createFinancialInstitution', 'isLoading'], false)
    }

    case FinancialInstitutionsTypes.CREATE_FINANCIAL_INSTITUTION_FAILURE: {
      return state.setIn(['createFinancialInstitution', 'isLoading'], false)
    }

    case FinancialInstitutionsTypes.DELETE_FINANCIAL_INSTITUTION_REQUEST: {
      return state
    }

    case FinancialInstitutionsTypes.DELETE_FINANCIAL_INSTITUTION_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case FinancialInstitutionsTypes.DELETE_FINANCIAL_INSTITUTION_FAILURE: {
      return state
    }

    case FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTIONS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTIONS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTIONS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTION_REQUEST: {
      return state.setIn(['updateFinancialInstitution', 'isLoading'], true)
    }

    case FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTION_SUCCESS: {
      return state
        .setIn(['updateFinancialInstitution', 'isLoading'], false)
        .setIn(
          ['updateFinancialInstitution', 'data'],
          fromJS(action.payload).delete('streetType').delete('id'),
        )
    }

    case FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTION_FAILURE: {
      return state.setIn(['updateFinancialInstitution', 'isLoading'], false)
    }

    case FinancialInstitutionsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case FinancialInstitutionsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
